import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Carousel, Card} from 'react-bootstrap';
import htmr from 'htmr';
import * as styles from './signup.module.scss';
import {ctaClickAction} from '../Shared/TrackActionService';

/**
 *
 *
 * @export
 * @class SingleChoiceForm
 * @extends {Component}
 */
export default class SingleChoiceForm extends Component {
  /**
   * Creates an instance of SingleChoiceForm.
   * @param {*} props
   * @memberof SingleChoiceForm
   */
  constructor(props) {
    super(props);
    this.carouselRef = React.createRef();
  }

  /**
   *
   * fired on mount of component
   * @memberof SingleChoiceForm
   */
  componentDidMount() {
    const intervalId = setInterval(() => {
      const node = this.carouselRef.current;
      if (node) {
        if (this.props.courseSlug && this.props.courseName) {
          const courseNameInRegFormRef =
            node.querySelector('#courseNameInRegForm');
          if (courseNameInRegFormRef) {
            courseNameInRegFormRef.textContent = this.props.courseName;
          }
          const courseCardImgInRegFormRef =
            node.querySelector('#courseCardImageInRegForm');
          if (courseCardImgInRegFormRef) {
            courseCardImgInRegFormRef.style.display = 'block';
            courseCardImgInRegFormRef.src =
              `${process.env.AssetsCDN}/course-images/en/${
                this.props.courseSlug}/website-square.png`;
          }
          clearInterval(intervalId);
        } else {
          const courseCardImgInRegFormRef =
            node.querySelector('#courseCardImageInRegForm');
          courseCardImgInRegFormRef.style.display = 'block';
          clearInterval(intervalId);
        }
      }
    }, 50);
  }

  /**
   *
   *
   * @param {*} index
   * @memberof SingleChoiceForm
   */
  triggerNextStep = (index) => {
    const {nextStep} = this.props;
    const {modular_blocks: modularBlocks} = this.props.data;
    const buttonCta = modularBlocks[index].carouseltems.buttoncta;
    const ctaClickTrackObject = {
      'cta': buttonCta,
      'action': `MultiStep-${nextStep}`,
      'pageKind': `MutiStepForm`,
    };
    ctaClickAction(ctaClickTrackObject);
    this.props.jumpToStep(nextStep);
  }

  /**
   *
   *
   * @return {*}
   * @memberof SingleChoiceForm
   */
  render() {
    const {selectedCarouselScreen} = this.props;
    const {subtext, single_line: singleLine} = this.props.data;
    const {modular_blocks: modularBlocks} = this.props.data;

    return (
      <div className={`${styles.primaryContainer2}
      ${styles.secondaryContainer}`}>
        <div className={styles.headingSection}>
          <p className={styles.heading}>
            {singleLine}
          </p>
          <p className={styles.subheading}>
            {subtext}
          </p>
        </div>
        <div className={styles.singleChoiceContainer}>
          <div className={styles.singleChoiceInnerContainer}>
            {modularBlocks.map((block, index) => (
              <div className={styles.singleChoiceWrapper}
                ref={this.carouselRef} key={index}>
                {htmr(block.carouseltems.content)}
                <button className={styles.shBtn}
                  onClick={() => this.triggerNextStep(index)}>
                  {block.carouseltems.buttoncta}
                </button>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }
}

SingleChoiceForm.propTypes = {
  jumpToStep: PropTypes.func,
  nextStep: PropTypes.number,
  selectedCarouselScreen: PropTypes.number,
  data: PropTypes.any,
  courseName: PropTypes.string,
  courseSlug: PropTypes.string,
};
